export default {
  label: 'Fale com a nossa equipa',
  label_unread: 'Fale com a nossa equipa, {{count}} nova(s)',
};
